import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "businessTypeInput", "businessTypeArea",
    "mfAcknowledgmentInput", "paymentArea",
    "isBillingSameInput", "billingArea",
    "deliveryMethodInput", "deliveryYamatoArea", "deliveryInHouseArea",
    "submitButton"
  ];

  connect() {
    this.toggleBusinessTypeArea();
    this.togglePaymentArea();
    this.toggleBillingArea();
    this.toggleDeliveryArea();
    this.toggleSubmitButton();
  }

  toggleBusinessTypeArea() {
    const businessTypeInput = this.businessTypeInputTarget?.value;
    this.businessTypeAreaTarget.style.display = "none";
    this.deliveryInHouseAreaTarget.style.display = "none";
    if (businessTypeInput == "other") {
      this.businessTypeAreaTarget.style.display = "contents";
    }
  }

  togglePaymentArea() {
    const checked = this.mfAcknowledgmentInputTarget.checked;
    if (checked) {
      this.paymentAreaTarget.style.display = "contents";
    } else {
      this.paymentAreaTarget.style.display = "none";
    }
    this.toggleSubmitButton();
  }

  toggleBillingArea() {
    const isBillingSameInput = this.isBillingSameInputTargets.find((radio) => radio.checked)?.value;
    if (isBillingSameInput != "false") {
      this.billingAreaTarget.style.display = "none";
    } else {
      this.billingAreaTarget.style.display = "contents";
    }
  }

  toggleDeliveryArea() {
    const deliveryMethodInput = this.deliveryMethodInputTarget?.value;
    this.deliveryYamatoAreaTarget.style.display = "none";
    this.deliveryInHouseAreaTarget.style.display = "none";
    if (deliveryMethodInput == "yamato") {
      this.deliveryYamatoAreaTarget.style.display = "contents";
    } else if (deliveryMethodInput == "in_house") {
      this.deliveryInHouseAreaTarget.style.display = "contents";
    }
  }

  toggleSubmitButton() {
    const checked = this.mfAcknowledgmentInputTarget.checked;
    if (checked) {
      this.submitButtonTarget.disabled = false;
    } else {
      this.submitButtonTarget.disabled = true;
    }
  }
}
